import { Box } from 'rebass'
import styled, { css } from 'styled-components'

const Container = styled(Box)`
  max-width: 1440px;
  margin: 0 auto;

  ${props =>
    props.zebra &&
    css`
      &:before {
        content: '';
        background: ${props.theme.colors.black};
        position: absolute;
        width: 50%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
      }
      &:after {
        content: '';
        background: ${props.theme.colors.yellow};
        position: absolute;
        width: 50%;
        height: 100%;
        right: 0;
        top: 0;
        z-index: -1;
      }
    `}

  ${props =>
    props.padded &&
    css`
      padding: 0 ${props.theme.space[5]}px;
    `}
`

export default Container
